export default __webpack_public_path__ + "static/media/FuturaStdBook.5f83b004.otf";